import { Type, type Static } from "@sinclair/typebox";
import { ProjectIdSchema, RoomIdSchema } from "./identifiers.ts";

export const ProjectRoomBindingSchema = Type.Object(
  {
    projectId: ProjectIdSchema,
    roomId: RoomIdSchema
  },
  { additionalProperties: false }
);
export type ProjectRoomBindingV1 = Static<typeof ProjectRoomBindingSchema>;
